export default {"src":"/_next/static/media/betterplaceLogo.dec87337.svg","height":26,"width":167,"blurWidth":0,"blurHeight":0};